import { useEffect, useState, useRef } from 'react';
import styles from './checkbox.module.css';

export default function Checkbox ({ hasSelectAll, options, handleChange }) {
  const [selectAllClicked, setSelectAllClicked] = useState(false);
  const [isAllChecked, setIsAllChecked] = useState(null);
  const [isWaving, setIsWaving] = useState(false);
  const waveTimeouts = useRef([]);

  useEffect(() => {
    setIsAllChecked(
      !options.some((option) => option.isChecked === false) ? true : null
    );
  }, []);

  const clearWaveTimeouts = () => {
    waveTimeouts.current.forEach((timeout) => clearTimeout(timeout));
    waveTimeouts.current = [];
  };

  useEffect(() => {
    if (isAllChecked != null && selectAllClicked) {
      clearWaveTimeouts();

      if (isAllChecked) {
        setIsWaving(true);

        const uncheckedIndices = options
          .map((option, index) => ({ option, index }))
          .filter(({ option }) => !option.isChecked)
          .map(({ index }) => index);

        if (uncheckedIndices.length === 0) {
          options.map((option) => {
            option.isChecked = true;
          });
          handleChange(options);
          setIsWaving(false);
          setSelectAllClicked(false);
        } else {
          uncheckedIndices.forEach((index, waveIndex) => {
            const timeout = setTimeout(() => {
              const tempOptions = [...options];
              tempOptions[index].isChecked = true;
              handleChange(tempOptions);

              if (waveIndex === uncheckedIndices.length - 1) {
                setIsWaving(false);
                setSelectAllClicked(false);
              }
            }, waveIndex * 15); // this is the delay between the boxes becoming checked

            waveTimeouts.current.push(timeout);
          });
        }
      } else {
        options.map((option) => {
          option.isChecked = false;
        });
        handleChange(options);
        setSelectAllClicked(false);
      }
    }
  }, [selectAllClicked]);

  useEffect(() => {
    return () => clearWaveTimeouts();
  }, []);

  return (
    <div className={`${styles.multiCheckboxContainer}`}>
      {hasSelectAll && (
        <div className={`${styles.checkboxController}`}>
          <input
            required={false}
            type='checkbox'
            id='select-all'
            className={`${styles.checkboxCustom}`}
            checked={isAllChecked || false}
            disabled={isWaving}
            onClick={() => {
              if (isWaving) return;
              setSelectAllClicked(!selectAllClicked);
              setIsAllChecked(!isAllChecked);
            }}
          />
          <label
            className={`${styles.checkboxText} ${
              isWaving ? styles.disabled : ''
            }`}
            style={{ fontWeight: 700 }}
            htmlFor='select-all'
          >
            Select All
          </label>
        </div>
      )}
      {options.map((option, index) => (
        <div
          key={`${option.value}-${index}`}
          className={`${styles.checkboxController}`}
        >
          <input
            required={false}
            type='checkbox'
            id={`${option.value}-${index}`}
            className={`${styles.checkboxCustom}`}
            checked={option.isChecked}
            disabled={isWaving}
            onClick={() => {
              if (isWaving) return; // disable click while the wave is happening

              const tempOptions = [...options];
              tempOptions[index].isChecked = !tempOptions[index].isChecked;
              setIsAllChecked(
                !tempOptions.some((option) => option.isChecked === false)
                  ? true
                  : null
              );
              handleChange(tempOptions);
            }}
          />
          <label
            className={`${styles.checkboxText} ${
              isWaving ? styles.disabled : ''
            }`}
            htmlFor={`${option.value}-${index}`}
          >
            {option.label}
          </label>
        </div>
      ))}
    </div>
  );
}
